import React, { useState, useEffect } from "react";
import { Grid, Box, Container, CardContent, Card } from "@mui/material";
import axios from "axios";
import qs from "qs";
import VirtualizedMultiSelect from "components/General/VirtualizedMultiSelect";
import { Line } from "react-chartjs-2";

const formControl = {
  margin: 1,
  minWidth: 120,
  maxWidth: 200,
};

const ProvinceSales = ({
  startDate,
  endDate,
  province,
  provinceDefaultStore,
  getProvinceData,
}) => {
  const [provinceStores, setProvinceStores] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [provinceSales, setProvinceSales] = useState([]);
  const [storeSales, setStoreSales] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [storePaymentMethod, setStorePaymentMethod] = useState([]);
  const paymentTypes = [
    "Cash",
    "Debit",
    "Visa",
    "Master",
    "American Express",
    "Gift Card",
  ];
  const isAllPaymentSelected =
    paymentTypes.length > 0 && paymentMethod.length === paymentTypes.length;
  const isAllStorePaymentSelected =
    paymentTypes.length > 0 &&
    storePaymentMethod.length === paymentTypes.length;
  const isAllProvinceStoresSelected =
    transactions.length > 0 && provinceStores.length === transactions.length;

  const handlePaymentType = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === "all") {
      setPaymentMethod(
        paymentMethod.length === paymentTypes.length ? [] : paymentTypes,
      );
      return;
    }
    setPaymentMethod(value);
  };

  const handleStorePaymentType = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === "all") {
      setStorePaymentMethod(
        storePaymentMethod.length === paymentTypes.length ? [] : paymentTypes,
      );
      return;
    }
    setStorePaymentMethod(value);
  };

  useEffect(async () => {
    const result = await axios.get(
      "/api/provinceSales/",
      {
        params: {
          province: province,
          startDate: startDate,
          endDate: endDate,
          paymentType: paymentMethod,
        },
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      },
    );
    setProvinceSales(result.data);
  }, [province, startDate, endDate, paymentMethod]);

  useEffect(() => {
    axios
      .get("/api/provinceStores/", {
        params: {
          province: province,
        },
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      })
      .then((res) => {
        setTransactions(res.data);
      });
  }, [province]);

  useEffect(async () => {
    const result = await axios.get(
      "/api/provinceSales/",
      {
        params: {
          storeId: provinceDefaultStore,
          startDate: startDate,
          endDate: endDate,
          paymentType: storePaymentMethod,
        },
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      },
    );
    setStoreSales(result.data);
  }, [provinceDefaultStore, storePaymentMethod]);

  useEffect(async () => {
    const result = await axios.get("/api/purchase/", {
      params: {
        storeId: provinceStores,
        startDate: startDate,
        endDate: endDate,
        paymentType: storePaymentMethod,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
    setStoreSales(result.data);
  }, [provinceStores, storePaymentMethod, startDate, endDate]);

  console.log(transactions);

  const handleProvinceStores = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === "all") {
      setProvinceStores(
        provinceStores.length === transactions.length ? [] : transactions,
      );
      return;
    }
    setProvinceStores(value);
  };

  return (
    <Container maxWidth={false}>
      <Grid container spacing={1}>
        <Grid item md={12} xs={12}>
          <Box ml={3}>
            <Card sx={{ height: "100%" }}>
              <CardContent>
                <Box pt={1} pb={3}>
                  <VirtualizedMultiSelect
                    label="Payment type"
                    id="paymentType-mutiple-checkbox"
                    value={paymentMethod}
                    options={paymentTypes}
                    onChange={handlePaymentType}
                    minWidth={200}
                    paperWidth={200}
                    formControlSx={formControl}
                    showSelectAll
                    selectAllChecked={isAllPaymentSelected}
                    selectAllIndeterminate={
                      paymentMethod.length > 0 &&
                      paymentMethod.length < paymentTypes.length
                    }
                  />
                </Box>

                <Grid item md={12} xs={12}>
                  <Line
                    data={provinceSales.sales}
                    options={{
                      title: {
                        display: true,
                        text: "ProvinceSales",
                        fontSize: 16,
                      },
                      legend: {
                        display: true,
                        position: "top",
                      },
                    }}
                  />
                </Grid>
              </CardContent>
            </Card>
          </Box>
        </Grid>
      </Grid>
      <Box pt={3} pl={3}>
        <Grid item md={12} xs={12}>
          <Card>
            <CardContent>
              <Box pt={3} pl={3}>
                <Grid container spacing={1}>
                  <Grid item md={6} xs={6}>
                    <VirtualizedMultiSelect
                      label="Province Stores"
                      id="provincestores-mutiple-checkbox"
                      value={provinceStores}
                      options={transactions}
                      onChange={handleProvinceStores}
                      minWidth={200}
                      paperWidth={200}
                      formControlSx={formControl}
                      showSelectAll
                      selectAllChecked={isAllProvinceStoresSelected}
                      selectAllIndeterminate={
                        provinceStores.length > 0 &&
                        provinceStores.length < transactions.length
                      }
                    />
                  </Grid>

                  <Box pt={1} pb={3}>
                    <Grid item md={3} xs={3}>
                      <VirtualizedMultiSelect
                        label="Payment type"
                        id="paymentStores-mutiple-checkbox"
                        value={storePaymentMethod}
                        options={paymentTypes}
                        onChange={handleStorePaymentType}
                        minWidth={200}
                        paperWidth={200}
                        formControlSx={formControl}
                        showSelectAll
                        selectAllChecked={isAllStorePaymentSelected}
                        selectAllIndeterminate={
                          storePaymentMethod.length > 0 &&
                          storePaymentMethod.length < paymentTypes.length
                        }
                      />
                    </Grid>
                  </Box>

                  <Grid item md={12} xs={12}>
                    <Box pt={2}>
                      <Line
                        data={storeSales}
                        options={{
                          title: {
                            display: true,
                            text: "ProvinceSales",
                            fontSize: 16,
                          },
                          legend: {
                            display: true,
                            position: "top",
                          },
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Box>
    </Container>
  );
};
export default ProvinceSales;
